import { stringify } from 'query-string';
import { useCallback } from 'react';
import { LoginRoute } from '../../constants/Routes';
import { PAGE_RESTRICTED_FLAG } from 'app/models/auth/constants';
import { useHistory } from 'app/components/router/History';
import { getRedirectTo } from 'app/models/route/selectors';

export default function useUnauthenticatedRedirect(): () => void {
  const history = useHistory();

  const unauthenticatedRedirect = useCallback(() => {
    const redirectTo = getRedirectTo(history);

    history.replace({
      pathname: LoginRoute.getPathname(),
      search: stringify({ restricted: PAGE_RESTRICTED_FLAG, redirectTo }),
    });
  }, [history]);

  return unauthenticatedRedirect;
}
